import {
  DatepickerRangeFooterProps,
  DatepickerSingleFooterProps,
} from './Sections/Footer/DatepickerFooter.consts';

export type DatepickerCalendarDayProps = {
  day: number;
  className: string;
};

export type DatepickerRangeProps = {
  presetDate?: string;
} & DatepickerRangeFooterProps;

export type DatepickerSingleProps = {
  presetDate?: string;
} & DatepickerSingleFooterProps;

export type DatepickerSingleInputProps = {
  presetValue?: string;
  onSelect: (date: string) => void;
};

export type DatepickerRangeTriggerProps = {
  onSelect: (startDate: string, endDate: string) => void;
};

export enum DatepickerType {
  SINGLE = 'single',
  RANGE = 'range',
}

export type DatepickerProps = {
  presetDate?: string;
  type: DatepickerType;
} & Partial<DatepickerRangeFooterProps> &
  Partial<DatepickerSingleFooterProps>;

export const weekDays = ['Mo', 'Tu', 'We', 'Th', 'Fri', 'Sa', 'Su'];

export const monthsNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const startYear = 2023;

export enum DAY_TYPE {
  PREV_MONTH = -1,
  NEXT_MONTH = 1,
  CURRENT_MONTH = 0,
}
